export default __webpack_public_path__ + "static/media/sunglasses.19135ff2.jfif";